import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate, useParams, Link } from "react-router-dom";
import Modal from "react-bootstrap/Modal";

const API = process.env.REACT_APP_API_URL || "http://localhost:5000/";

const PerformanceReview = () => {
  const MANAGER_ID = JSON.parse(localStorage.getItem("userId"));
  const { employeeId, date, day, month, year } = useParams();
  const navigate = useNavigate();
  const token = JSON.parse(localStorage.getItem("key"));
  const [data, setData] = useState(null);
  const [reviewStatus, setReviewStatus] = useState("");
  const [statusKpi, setKpiStatus] = useState("");
  const [rating, setRating] = useState("");
  const [comment, setComment] = useState("");
  const [saving, setSaving] = useState(false);
  const [loading, setLoading] = useState(true);
  const [kraList, setKraList] = useState([]);
  const [modalReview, setModalReview] = useState(false);

  useEffect(() => {
    loadKra();
  }, []);
  const restReview = async () => {
    setReviewStatus("");
    setRating("");
    setKpiStatus("");
    setComment("");
    setModalReview(false);
  };

  const openReviewModelHandler = () => {
    setModalReview(true);
  };
  const handleClose = () => {
    setModalReview(false);
  };
  const loadKra = async () => {
    try {
      const res = await axios.get(`${API}api/Performance/kra`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });

      if (res.data.success) {
        setKraList(res.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const loadReview = async () => {
    try {
      setLoading(true);

      const response = await axios.get(
        `${API}api/Performance/review/${employeeId}`,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            Authorization: `Bearer ${token.value}`,
          },
          params: {
            manager_id: MANAGER_ID,
            day: day,
            month: month,
            year: year,
            date: date,
          },
        },
      );

      const result = response.data.data;
      // const result = {
      //   data: {
      //     employee_id: 101,
      //     employee_name: "Rahul Kumar",
      //     employee_code: "EMP001",
      //     department_name: "Editorial",
      //     manager_id: 205,
      //     manager_name: "Amit Sharma",
      //     review_date: "2026-09-14",

      //     attendance: {
      //       login_time: "09:30:00",
      //       logout_time: "18:15:00",
      //       worked_minutes: 525,
      //       allocated_hours: 8,
      //       completed_hours: 8.75,
      //       hours_score: 100,
      //     },

      //     allocation: {
      //       total_allotted_pages: 100,
      //       total_completed_pages: 95,
      //       page_score: 95,

      //       total_allotted_hours: 8,
      //       total_completed_hours: 7.6,
      //       hours_score: 95,

      //       allocation_score: 95,

      //       allocations: [
      //         {
      //           allocation_id: 1,
      //           task_name: "Editing",
      //           allotted_pages: 100,
      //           completed_pages: 95,
      //           page_score: 95,
      //           allotted_hours: 8,
      //           completed_hours: 7.6,
      //           hours_score: 95,
      //         },
      //       ],
      //     },

      //     kpis: [
      //       {
      //         employee_kpi_id: 1,
      //         kra_id: 1,
      //         kra_name: "Quality",
      //         kpi_id: 1,
      //         kpi_name: "Page Accuracy",
      //         target_value: 100,
      //         target_unit: "Pages",
      //         actual_value: 95,
      //         weight: 30,
      //         score: 95,
      //         weighted_score: 28.5,
      //       },
      //     ],

      //     kpi_score: 28.5,
      //     daily_score: 95,
      //     final_score: 91.75,

      //     review: {
      //       status: "Pending",
      //       manager_rating: null,
      //       manager_comment: null,
      //       rejection_reason: null,
      //     },
      //   },
      // };
      console.log("Performance Review:", result);
      setData(result);

      if (result?.review) {
        setRating(result.review.manager_rating || "");
        setComment(result.review.manager_comment || "");
      }
    } catch (error) {
      console.error("Load review error:", error);

      alert(
        error.response?.data?.message || "Unable to load performance review",
      );
    } finally {
      setLoading(false);
    }
  };

  const submitReview = async (action) => {
    if (action === "Approved" && !rating) {
      alert("Please select manager rating");
      return;
    }
    if (reviewStatus != 1 && !reviewStatus) {
      alert("Please select review status");
      return;
    }

    const confirmed = window.confirm(
      `Are you sure you want to ${action.toLowerCase()} this performance?`,
    );

    if (!confirmed) {
      return;
    }

    try {
      setSaving(true);

      const endpoint = `${API}api/Performance/savePerformance`;
      console.log("Performance Review data:", data);
      const payload = {
        employee_id: employeeId,
        review_date: date,
        month: month,
        year: year,

        allocation_score: Number(data?.allocation.allocation_score || 0),
        hours_score: Number(data?.allocation.hours_score || 0),
        daily_score: Number(data?.daily_score || 0),

        kpi_score: Number(data?.kpi_score || 0),
        final_score: Number(data?.final_score || 0),

        manager_id: MANAGER_ID,

        kra_id: statusKpi || null,

        rating: rating ? Number(rating) : null,

        comment: comment?.trim() || null,

        status: reviewStatus,
      };

      console.log("Save Performance Payload:", payload);

      const response = await axios.post(endpoint, payload, {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: `Bearer ${token.value}`,
        },
      });

      console.log("Save Performance Response:", response.data);

      alert(
        response.action === "inserted"
          ? "Performance approved insert successfully"
          : "Performance approved Update successfully",
      );

      navigate("/Allocation?allocationsList");
    } catch (error) {
      console.error("Submit review error:", error);

      alert(
        error.response?.data?.message || "Unable to save performance review",
      );
    } finally {
      setSaving(false);
    }
  };
  useEffect(() => {
    loadReview();
  }, [employeeId, month, year]);

  if (!data) {
    return (
      <div className="performance-loading">Performance review not found.</div>
    );
  }

  const status = data.review?.status || "Pending";

  const attendance = data.attendance || {};

  const allocation = data.allocation || {};

  const allocations = data.allocations || [];

  const kpis = data.kpis || [];

  return (
    <>
      <Modal show={modalReview} size="sl" id="reviewmodal">
        <div className="modal-body">
          <div className="decorative-shape shape-1"></div>
          <div className="decorative-shape shape-2"></div>
          <button
            type="button"
            className="float-end btn_close"
            data-bs-dismiss="modal"
            aria-label="Close"
            onClick={handleClose}
          >
            <i className="icon icon-cross fw-bold"></i>
          </button>
          <div
            className="dash_white_box_ttl text-center"
            id="exampleModalLabel"
          >
            Review Approval
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Manager Rating</label>

            <select
              className="form-select"
              value={rating}
              disabled={status !== "Pending" || saving}
              onChange={(e) => setRating(e.target.value)}
            >
              <option value="">Select Rating</option>

              <option value="1">1 - Poor</option>

              <option value="2">2 - Needs Improvement</option>

              <option value="3">3 - Good</option>

              <option value="4">4 - Very Good</option>

              <option value="5">5 - Excellent</option>
            </select>
          </div>
          <div className="mb-3">
            <label className="form-label fw-semibold">Review Status</label>

            <select
              className="form-select"
              value={reviewStatus}
              onChange={(e) => setReviewStatus(e.target.value)}
            >
              <option value="">Select Review Status</option>

              <option value="1">Pending</option>
              <option value="2">Approved</option>
              <option value="3">Reject</option>
            </select>
          </div>
          <div className="md-3">
            <label className="form-label fw-semibold">KPI Status</label>
            <select
              className="form-select"
              value={statusKpi}
              onChange={(e) => setKpiStatus(e.target.value)}
            >
              <option value="">Select KPI</option>
              {kraList.map((kra) => (
                <option key={kra.id} value={kra.id}>
                  {kra.kra_code} - {kra.kra_name}
                </option>
              ))}
            </select>
          </div>
          <div className="md-3">
            <label className="form-label fw-semibold">Manager Comment</label>

            <textarea
              rows="5"
              className="form-control"
              placeholder="Enter manager comments..."
              value={comment}
              disabled={status !== "Pending" || saving}
              onChange={(e) => setComment(e.target.value)}
            />
          </div>

          {data.review?.rejection_reason && (
            <div className="alert alert-danger mt-3">
              <strong>Rejection Reason:</strong> {data.review.rejection_reason}
            </div>
          )}
          {/* ================= ACTION BUTTONS ================= */}
          <div className="modalfooter">
            {/* <span className="mb10 d-block text-right">{msg}</span> */}
            <div className="row">
              <div className="col-md-6 pr07">
                <button
                  type="button"
                  className="btn_5 w-100"
                  disabled={saving}
                  onClick={() => submitReview("Approved")}
                >
                  {saving ? "Saving..." : "Approve"}
                </button>
              </div>
              <div className="col-md-6 pl07">
                <button
                  type="button"
                  disabled={saving}
                  onClick={() => restReview("Reset")}
                  className="btn_6 w-100"
                  data-bs-dismiss="modal"
                >
                  {saving ? "Saving..." : "Reset"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </Modal>
      <div className="page-header">
        <h1>
          Daily Performance Approval
          <button
            type="button"
            className="btn btn-sm btn-info mr08 float-end"
            onClick={openReviewModelHandler}
          >
            Review Approval
          </button>
          <button
            type="button"
            className="btn btn-sm btn-warning float-end mr08"
            onClick={() => navigate("/Allocation?allocationsList")}
          >
            ← Back
          </button>
        </h1>
        <ul id="breadcrumbs" className="breadcrumb mb00">
          <li>
            <Link to="/dashboard">Dashboard </Link>
          </li>
          <li>
            <Link to="/employeelist">
              <span>/</span>Performance{" "}
            </Link>
          </li>
          <li className="current">
            <span>/</span>Approval
          </li>
        </ul>
      </div>
      <div className="row_bg">
        {loading ? (
          <div className="dash_white_box2 mb20 p20">
            <div className="row mb30">
              <div className="performance-loading">
                Loading performance review...
              </div>
            </div>
          </div>
        ) : (
          <>
            <div className="dash_white_box2 mb20 p20">
              <div className="row mb30">
                {/* ================= EMPLOYEE DETAILS ================= */}
                <div className="col-md-3">
                  <div className="dash_white_box_ttl">Employee Details</div>

                  {/* Employee */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Employee:</strong>{" "}
                    <span>{data.employee.employee_name}</span>
                  </div>

                  {/* Employee Code */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Employee Code:</strong>
                    <span>{data.employee.employee_code}</span>
                  </div>

                  {/* Department */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Department:</strong>{" "}
                    <span> {data.employee.department_name}</span>
                  </div>

                  {/* Review Date */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Review Date:</strong>{" "}
                    <span> {data.review_date}</span>
                  </div>

                  {/* Manager */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Manager:</strong>{" "}
                    <span> {data.employee.manager_name}</span>
                  </div>

                  {/* Manager ID */}
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Manager ID:</strong>{" "}
                    <span> {data.employee.manager_id}</span>
                  </div>
                </div>
                {/* ================= Attendance DETAILS ================= */}
                <div className="col-md-3">
                  <div className="dash_white_box_ttl">Attendance</div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Login Time:</strong>{" "}
                    <span> {attendance.login_time || "00:00"}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Logout Time:</strong>{" "}
                    <span> {attendance.logout_time || "00:00"}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Allocated Hours:</strong>{" "}
                    <span>
                      {" "}
                      {`${Number(attendance.allocated_hours || 0).toFixed(2)} hrs`}
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Completed Hours:</strong>{" "}
                    <span>
                      {" "}
                      {`${Number(attendance.completed_hours || 0).toFixed(2)} hrs`}
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Worked Minutes:</strong>{" "}
                    <span> {attendance.worked_minutes || 0}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Attendance Achievement:</strong>{" "}
                    <span>
                      {" "}
                      {`${Number(attendance.hours_score || 0).toFixed(2)}%`}
                    </span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dash_white_box_ttl">Performance Score</div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Attendance Score:</strong>{" "}
                    <span> {attendance.hours_score || "00:00"}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Daily Allocation Score:</strong>{" "}
                    <span> {allocation.allocation_score || 0}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>KPI Weighted Score:</strong>{" "}
                    <span> {data.kpi_score || 0}</span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Final Daily Performance:</strong>{" "}
                    <span> {data.final_score || 0}</span>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="dash_white_box_ttl">Allocation Summary</div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Page Score:</strong>{" "}
                    <span>
                      {" "}
                      {Number(allocation.page_score || 0).toFixed(2)}%
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Allocation Hour Score:</strong>{" "}
                    <span>
                      {" "}
                      {Number(allocation.hours_score || 0).toFixed(2)}%
                    </span>
                  </div>
                  <div className="col-md-12 mb-6 mb10">
                    <strong>Daily Allocation Score:</strong>{" "}
                    <span>
                      {" "}
                      {Number(allocation.allocation_score || 0).toFixed(2)}%
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="dash_white_box2 mb20 p20">
              <div className="dash_white_box_ttl">Daily Allocation</div>
              <div className="row mb30">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table_style_1 table-bordered review-table">
                      <thead>
                        <tr>
                          <th>Task / Allocation</th>
                          <th>Stage</th>
                          <th>Allocated Pages</th>
                          <th>Completed Pages</th>
                          <th>Page Achievement</th>
                          <th>Allocated Hours</th>
                          <th>Completed Hours</th>
                          <th>Hour Achievement</th>
                        </tr>
                      </thead>

                      <tbody>
                        {allocations.length === 0 ? (
                          <tr>
                            <td colSpan="7" className="text-center">
                              No allocation found for this date.
                            </td>
                          </tr>
                        ) : (
                          allocations.map((item) => (
                            <tr key={item.allocation_id}>
                              <td>
                                {item.task_name || item.stage_name || "-"}
                              </td>
                              <td>{item.stage_name || "-"}</td>

                              <td>
                                {Number(item.allotted_pages || 0).toFixed(2)}
                              </td>

                              <td>
                                {Number(item.completed_pages || 0).toFixed(2)}
                              </td>

                              <td>
                                <strong>
                                  {Number(item.page_score || 0).toFixed(2)}%
                                </strong>
                              </td>

                              <td>
                                {Number(item.allotted_hours || 0).toFixed(2)}
                              </td>

                              <td>
                                {Number(item.completed_hours || 0).toFixed(2)}
                              </td>

                              <td>
                                <strong>
                                  {Number(item.hours_score || 0).toFixed(2)}%
                                </strong>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>

                      <tfoot>
                        <tr>
                          <th colSpan="2">Total</th>

                          <th>
                            {Number(
                              allocation.total_allotted_pages || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(
                              allocation.total_completed_pages || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(allocation.page_score || 0).toFixed(2)}%
                          </th>

                          <th>
                            {Number(
                              allocation.total_allotted_hours || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(
                              allocation.total_completed_hours || 0,
                            ).toFixed(2)}
                          </th>

                          <th>
                            {Number(allocation.hours_score || 0).toFixed(2)}%
                          </th>
                        </tr>
                      </tfoot>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div className="dash_white_box2 mb20 p20">
              <div className="dash_white_box_ttl">KPI / KRA Mapping</div>
              <div className="row mb30">
                <div className="col-md-12">
                  <div className="table-responsive">
                    <table className="table_style_1 table-bordered review-table">
                      <thead>
                        <tr>
                          <th>KRA</th>
                          <th>KPI</th>
                          <th>Target</th>
                          <th>Unit</th>
                          <th>Actual</th>
                          <th>Weight</th>
                          <th>Achievement</th>
                          <th>Weighted Score</th>
                        </tr>
                      </thead>

                      <tbody>
                        {kpis.length === 0 ? (
                          <tr>
                            <td colSpan="8" className="text-center">
                              No KPI/KRA mapping found.
                            </td>
                          </tr>
                        ) : (
                          kpis.map((item) => (
                            <tr key={item.employee_kpi_id || item.kpi_id}>
                              <td>{item.kra_name || "-"}</td>

                              <td>{item.kpi_name || "-"}</td>

                              <td>
                                {Number(item.target_value || 0).toFixed(2)}
                              </td>

                              <td>{item.target_unit || "-"}</td>

                              <td>
                                {Number(item.actual_value || 0).toFixed(2)}
                              </td>

                              <td>{Number(item.weight || 0).toFixed(2)}%</td>

                              <td>
                                <strong>
                                  {Number(item.score || 0).toFixed(2)}%
                                </strong>
                              </td>

                              <td>
                                <strong>
                                  {Number(item.weighted_score || 0).toFixed(2)}%
                                </strong>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default PerformanceReview;
